'use client'

import React, { HTMLAttributes } from 'react'

import { cn } from '@podo-app/design-system-temp'

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full'
  children: React.ReactNode
}

const Container = ({ size = 'lg', className, children, ...props }: ContainerProps) => {
  const sizeClasses = {
    sm: 'max-w-sm', // 384px
    md: 'max-w-md', // 448px
    lg: 'max-w-4xl', // 896px
    xl: 'max-w-6xl', // 1152px
    full: 'max-w-full', // 100%
  }

  return (
    <div className={cn('w-full mx-auto px-2.5', sizeClasses[size], className)} {...props}>
      {children}
    </div>
  )
}

export default Container
